import React from 'react';
const BoostIllustration = ()=>{
    return /*#__PURE__*/ React.createElement("img", {
        width: "96",
        src: "//st.deviantart.net/eclipse/illustrations/boost-deviation.png",
        alt: "rocket flying in space"
    });
};
BoostIllustration.displayName = 'BoostIllustration';
export default BoostIllustration;

//# sourceMappingURL=BoostIllustration.js.map